export const emptyCourseText = {
    NoCourse: {
        en: "No Course Found!",
        mr: "कोणताही कोर्स सापडला नाही!",
    },
    Message: {
        en: "There is no course assigned for you at the moment.",
        mr: "सध्या तुमच्यासाठी कोणताही कोर्स नियुक्त केलेला नाही.",
    },
    GoBack: {
        en: "Go back",
        mr: "परत जा",
    },
};
